import { useContext } from "react";
import { IASMAContext } from "./IASMAContext";

export const useIASMA = () => {
	const context = useContext(IASMAContext);
	if (!context) {
		throw new Error('useIASMA must be used within an IASMAProvider');
	}
	return context;
};

